import CMSPage from '../../components/CMSPage/CMSPage';

const NewsPage = () => {
  return <CMSPage pageType="news" />;
};

export default NewsPage;
